import axios from 'axios';

const UploaderFile = async (file: File) => {
	const newData = new FormData();
	newData.append('file', file);

	const result = await axios.post('upload-file', newData);
	return result.data.data;
};
export default UploaderFile;
